import { render, staticRenderFns } from "./bulkactivation.vue?vue&type=template&id=ff02e390&scoped=true&"
import script from "./bulkactivation.vue?vue&type=script&lang=tsx&"
export * from "./bulkactivation.vue?vue&type=script&lang=tsx&"
import style0 from "./bulkactivation.vue?vue&type=style&index=0&id=ff02e390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff02e390",
  null
  
)

export default component.exports